/* @flow */
import InviteModal from 'users/components/InviteModal';
import Link from 'components/Link';
import ModalTrigger from 'components/ModalTrigger';
import PropTypes from 'prop-types';
import * as React from 'react';
import TitleHeader from 'components/TitleHeader';
import TriggerComposerButton from 'chat/components/TriggerComposerButton';

import './styles/GroupMessagesNull.scss';

export default class GroupMessagesNull extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    canChat: PropTypes.bool,
    canInviteTeachers: PropTypes.bool,
    canPost: PropTypes.bool,
  };

  static defaultProps = {
    canChat: false,
    canPost: false,
    canInviteTeachers: false,
  };

  getPosterUI() {
    const title = 'Send a welcome message!';
    const subtext = 'Let your class know how you’ll be using Remind.';
    const action = <TriggerComposerButton label="Send an announcement" />;

    return {
      title,
      subtext,
      action,
    };
  }

  getReceiverUI() {
    const title = 'No announcements yet';
    let subtext = 'We’ll let you know as soon as your teacher sends an announcement.';
    let action = null;

    if (this.props.canInviteTeachers) {
      subtext = (
        <span>
          While you’re waiting,{' '}
          <ModalTrigger modal={<InviteModal />}>
            <Link weight="semibold">share Remind</Link>
          </ModalTrigger>{' '}
          with other teachers!
        </span>
      );
    } else if (this.props.canChat) {
      subtext =
        'In the meantime, click on the New Message button to send your teacher questions, updates, and more.';
    }

    if (this.props.canChat) {
      action = <TriggerComposerButton label="Send a message" />;
    }

    return {
      title,
      subtext,
      action,
    };
  }

  render() {
    const { action, subtext, title } = this.props.canPost
      ? this.getPosterUI()
      : this.getReceiverUI();

    return (
      <TitleHeader
        image={require('assets/images/group-launch.svg')}
        imageSize="xxxsmall"
        title={title}
        subtext={subtext}
        action={action}
        className="GroupMessagesNull"
      />
    );
  }
}
